
export namespace Time {
    export function hoursInSeconds(hour: number): number {
        return hour * 60 * 60
    }

    export function hoursInMiliseconds(hour: number): number {
        return hoursInSeconds(hour) * 1000
    }

    export function hoursFromNowInMiliseconds(hour: number): number {
        return (new Date()).getTime() + hoursInMiliseconds(hour)
    }

    export function minutesInSeconds(minutes: number): number {
        return minutes * 60
    }
}